import { Instance } from 'mobx-state-tree'
import { RecursiveRemoveUndefined } from '../../utils'
import { GameArchiveEntityModelBase } from './GameArchiveEntityModel.base'

/* The TypeScript type of an instance of GameArchiveEntityModel */
export interface GameArchiveEntityModelType extends RecursiveRemoveUndefined<Instance<typeof GameArchiveEntityModel>> {}

/* A graphql query fragment builders for GameArchiveEntityModel */
export {
  selectFromGameArchiveEntity,
  gameArchiveEntityModelPrimitives,
  GameArchiveEntityModelSelector
} from './GameArchiveEntityModel.base'

/**
 * GameArchiveEntityModel
 */
export const GameArchiveEntityModel = GameArchiveEntityModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
